import { t } from "ttag";

import { shouldShowTenantsUpsell } from "metabase/admin/people/selectors";
import { useSetting } from "metabase/common/hooks";
import type { PaletteSubPath } from "metabase/palette/types";
import { useSelector } from "metabase/redux";

// Mirrors PeopleNav's own sub-page list and visibility conditions
// (frontend/src/metabase/admin/people/components/PeopleNav.tsx) so every
// sub-page reachable by browsing Admin > People's own sidebar is also
// reachable by name from the global command palette -- only the top-level
// "/admin/people" was searchable before this (WCAG 2.4.5 Multiple Ways).
export const usePeopleAdminPaths = (): PaletteSubPath[] => {
  const isUsingTenants = useSetting("use-tenants");
  const showTenantsUpsell = useSelector(shouldShowTenantsUpsell);
  const showTenants = isUsingTenants || (showTenantsUpsell && !isUsingTenants);

  const paths: (PaletteSubPath | null)[] = [
    {
      key: "people-groups",
      name: isUsingTenants
        ? `${t`People`} - ${t`Internal groups`}`
        : `${t`People`} - ${t`Groups`}`,
      path: "/admin/people/groups",
    },
    showTenants
      ? {
          key: "people-tenants",
          name: `${t`People`} - ${t`Tenants`}`,
          path: "/admin/people/tenants",
        }
      : null,
    isUsingTenants
      ? {
          key: "people-tenant-groups",
          name: `${t`People`} - ${t`Tenant groups`}`,
          path: "/admin/people/tenants/groups",
        }
      : null,
    isUsingTenants
      ? {
          key: "people-tenant-users",
          name: `${t`People`} - ${t`Tenant users`}`,
          path: "/admin/people/tenants/people",
        }
      : null,
  ];

  return paths.filter((path): path is PaletteSubPath => path !== null);
};
